// import TeamCard from "../components/TeamCard.jsx"
import {Link} from "react-router-dom"

export default function Home(){
 return(
  <>

   {/* HERO SECTION */}

   <section className="hero">

    <div className="left">

     <h1>Building Digital Solutions For Tomorrow</h1>

     <p>
      KPL Infotech provides ERP software, web development
      services and industrial training programs to help
      businesses and students grow with modern technology.
     </p>

     <Link className="hero-btn app-cta-link" to="/#services">Explore Services</Link>

    </div>

    <div className="right">

     <img src="/img1.jpg" alt="office"/>
     <img src="/img2.jpg" alt="coding"/>
     <img src="/img3.jpg" alt="team"/>

    </div>

   </section>


   {/* SERVICES */}

   <section className="home-services" id="services">

    <h2>Our Services</h2>

    <div className="service-grid">

     <Link className="service-card service-card-link" to="/erp">
      <h3>ERP Solutions</h3>
      <p>
       Customized ERP software for schools, institutes
       and businesses to manage operations efficiently.
      </p>
     </Link>

     <Link className="service-card service-card-link" to="/webdev">
      <h3>Web Development</h3>
      <p>
       Professional websites and web applications built
       using modern technologies like React and Node.js.
      </p>
     </Link>

     <Link className="service-card service-card-link" to="/training">
      <h3>Industrial Training</h3>
      <p>
       Hands-on training programs for B.Tech, BCA and
       MCA students to build real-world development skills.
      </p>
     </Link>

    </div>

   </section>


   {/* WHY CHOOSE US */}

   <section className="why-us">

    <h2>Why Choose Us</h2>

    <div className="why-grid">

     <div className="why-card">
      <h3>Industry Experience</h3>
      <p>Real-world development experience and live projects.</p>
     </div>

     <div className="why-card">
      <h3>Modern Technologies</h3>
      <p>We use the latest technologies to build scalable solutions.</p>
     </div>

     <div className="why-card">
      <h3>Quality Solutions</h3>
      <p>We focus on building reliable and user-friendly systems.</p>
     </div>

    </div>

   </section>


   {/* TEAM */}

   {/*
   <section className="team">

    <h2>Our Team</h2>

    <div className="team-box">

     <TeamCard
      name="Krishnkant"
      role="MERN Trainer"
      img="/t1.jpg"
     />

     <TeamCard
      name="Developer"
      role="Backend Developer"
      img="/t2.jpg"
     />

     <TeamCard
      name="Rahul Kumar"
      role="DevOps Engineer"
      img="/t3.jpg"
     />

    </div>

   </section>
   */}

   {/* CTA */}

   <section className="home-cta">

    <h2>Let's Build Something Great Together</h2>

    <p>
     Contact us today to discuss your project or enroll
     in our industrial training program.
    </p>

    <Link className="app-cta-link" to="/contact">Contact Us</Link>

   </section>

  </>
 )
}
